<template>
    <!--Edit-->
    <div class="container">
        <div class="page-inner">
            <div class="page-header gp-admin-page-heading">
                <h3 class="fw-bold">Aprovação de sinistro</h3>
                <ul class="breadcrumbs">
                    <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
                    <li class="separator"><i class="fa fa-chevron-right"></i></li>
                    <li class="nav-item"><a href="#" @click.prevent="$router.push('/listasinistrosaprovacao')">Sinistros para aprovação</a></li>
                    <li class="separator"><i class="fa fa-chevron-right"></i></li>
                    <li class="nav-item">Analisar</li>
                </ul>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="Sinistro!=''">
                    <div class="card gp-approval-card">
                        <div class="card-body">
                            <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                <v-tab value="dados" class="tabinfo"
                                    style="font-size: 13px;text-transform: none !important;"><v-icon size="16">mdi-clipboard-check-outline</v-icon> Aprovação do sinistro</v-tab>
                            </v-tabs>
                            <v-window v-model="tab">
                                <v-window-item value="dados">
                                    <v-form>
                                        <v-container>
                                            <div class="row">
                                                <v-col cols="12" md="6">
                                                    <v-card class="gp-approval-info-card">
                                                        <div>
                                                            <h5 class="gp-approval-card-title">
                                                                <v-icon size="18">mdi-shield-alert-outline</v-icon> Dados do sinistro
                                                            </h5>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Sinistro:</strong> {{ this.Sinistro.sntCodigo }} -
                                                                {{ this.Sinistro.tsnNome
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Garantidora:</strong> {{ this.Sinistro.garNome
                                                                }} - <strong>Imobiliária:</strong> {{ this.Sinistro.imoNome
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cliente:</strong> {{ this.Sinistro.pedDescricao
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Data Cadastro:</strong> {{
                                                                formattedDate(this.Sinistro.sntDtinclusao) }} <strong>Usuário:</strong> {{ this.Sinistro.cusNome }}
                                                            </p>
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                      <v-card v-if="PedidosEndereco != ''" class="gp-approval-info-card">
                                                        <div>
                                                            <h5 class="gp-approval-card-title"><v-icon size="18">mdi-map-marker-outline</v-icon> Endereço da contratação
                                                            </h5>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Endereço:</strong> {{
                                                                    PedidosEndereco[0].pdcEndereco
                                                                }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                    PedidosEndereco[0].pdcComplemento }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cidade/UF:</strong> {{
                                                                    PedidosEndereco[0].pdcCidade }} /
                                                                {{ PedidosEndereco[0].pdcEstado }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Bairro:</strong> {{
                                                                    PedidosEndereco[0].pdcBairro
                                                                }} -  <strong>CEP:</strong> {{
                                                                    PedidosEndereco[0].pdcCep }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Tipo Imóvel:</strong> {{
                                                                    PedidosEndereco[0].pdcTipo
                                                                }} {{ PedidosEndereco[0].pdcResidencialTipo
                                                                }}
                                                            </p>
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                            </div>
                                            <v-row class="gp-approval-details-row">
                                                <v-col cols="12" md="6">
                                                    <v-card v-if="PedidosEndereco != ''" class="gp-approval-info-card gp-approval-contract-card">
                                                        <div>
                                                            <h5 class="gp-approval-card-title"><v-icon size="18">mdi-file-sign</v-icon> Informações da contratação
                                                            </h5>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Contratação:</strong>  {{ Sinistro.pedId
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Vigência:</strong> {{  formattedDate(PedidoItem.pdiDataVigenciaIni) }} a  {{  formattedDate(PedidoItem.pdiDataVigenciaFim) }}
                                                            </p>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Produto:</strong> {{ PedidoItem.pdiNomeProduto }}
                                                            </p>
                                                              <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                  <strong>Cobertura:</strong> {{  this.DadosPedidoDocumento.multiplicador }} x {{ formatarValor(TotalCobertura)  }} = R$ {{ formatarValor(this.DadosPedidoDocumento.multiplicador*TotalCobertura) }}
                                                            </p>
                                                            <p class="gp-approval-balance">
                                                                <strong>Saldo Cobertura:</strong> {{ formatarValor((this.DadosPedidoDocumento.multiplicador*TotalCobertura) - (TotalSinistrosPagamento + TotalSinistroDebitoAndamento)) }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                 <v-row style="padding-top: 5px;padding-bottom: 5px;">
                                                                    <v-table style="background-color: transparent;">
                                                                        <thead>
                                                                            <tr>
                                                                            <th class="text-left">
                                                                                    Item
                                                                                </th>
                                                                                <th class="text-left">
                                                                                    Valor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item, index) in PedidoItemAdicional"
                                                                                :key="index">
                                                                                <td>{{ item.piaNomeProduto }}</td>
                                                                                <td>{{ formatarValor(item.piaValorTotalProduto) }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-table>
                                                                 </v-row>
                                                            </p>
                                                            <hr />
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Sinistros já pagos desta contratação: Total R$ {{ formatarValor(TotalSinistrosPagamento) }} </strong>
                                                                  <v-row style="padding-top: 5px;padding-bottom: 5px;" v-if="ListaSinistrosPagamento.length > 0">
                                                                    <v-table style="background-color: transparent;font-size: 12px;">
                                                                        <thead>
                                                                            <tr>
                                                                            <th class="text-left">
                                                                                    Sinistro
                                                                                </th>
                                                                                <th class="text-left">
                                                                                    Data Pgto
                                                                                </th>
                                                                                 <th class="text-left">
                                                                                    Valor
                                                                                </th>
                                                                                 <th class="text-left">
                                                                                    Status Sinistro
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item, index) in ListaSinistrosPagamento"
                                                                                :key="index">
                                                                                <td>{{ item.sntCodigo }}</td>
                                                                                <td>{{ formattedDate(item.snpDtPagamento) }}</td>
                                                                                <td>{{ formatarValor(item.snpValor) }}</td>
                                                                                <td>{{ item.sstNome }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-table>
                                                                 </v-row>
                                                                 <v-row v-else>
                                                                    <v-col cols="12" md="12" style="padding: 15px;">
                                                                       NADA CONSTA
                                                                    </v-col>
                                                                 </v-row>
                                                            </p>
                                                             <hr />
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Sinistros em Andamento: Total R$ {{ formatarValor(TotalSinistroDebitoAndamento) }} </strong>
                                                                 <v-row style="padding-top: 5px;padding-bottom: 5px;"  v-if="ListaSinistrosDebitoAndamento.length > 0">
                                                                    <v-table style="background-color: transparent;font-size: 12px;">
                                                                        <thead>
                                                                            <tr>
                                                                            <th class="text-left">
                                                                                    Sinistro
                                                                                </th>
                                                                                <th class="text-left">
                                                                                    Data Débito
                                                                                </th>
                                                                                 <th class="text-left">
                                                                                    Valor
                                                                                </th>
                                                                                 <th class="text-left">
                                                                                    Status Sinistro
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="(item, index) in ListaSinistrosDebitoAndamento"
                                                                                :key="index">
                                                                                <td>{{ item.sntCodigo }}</td>
                                                                                <td>{{ formattedDate(item.sdbDtDebito) }}</td>
                                                                                <td>{{ formatarValor(item.sdbValorDebito) }}</td>
                                                                                <td>{{ item.sstNome }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-table>
                                                                 </v-row>
                                                                 <v-row v-else>
                                                                    <v-col cols="12" md="12" style="padding: 15px;">
                                                                       NADA CONSTA
                                                                    </v-col>
                                                                 </v-row>
                                                            </p>
                                                            </div>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <section class="gp-approval-decision-card">
                                                     <h5 class="gp-approval-card-title"><v-icon size="18">mdi-cash-alert</v-icon> Informações do débito
                                                    </h5>
                                                    <v-row style="padding-top: 5px;padding-bottom: 5px;">
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Tipo
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Documento
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Visualização
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in ListaSinistroDocumentos"
                                                                    :key="index">
                                                                    <td>{{ item.docNome }}</td>
                                                                    <td>{{ item.sndNomeOriginal }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="item.sndNomeInterno != ''" icon
                                                                            @click.prevent="VisualizarDocumento(item.sndNomeInterno)"
                                                                            variant="text">
                                                                            <v-icon>mdi-file-eye</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Visualizar</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                     <v-row>
                                                        <p class="gp-approval-description">
                                                        {{ this.Sinistro.sntDescricao }}
                                                        </p>
                                                    </v-row>
                                                       <v-row style="padding-top: 5px;padding-bottom: 5px;">
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Tipo
                                                                    </th>
                                                                     <th class="text-left">
                                                                        Data
                                                                    </th>
                                                                     <th class="text-left">
                                                                        Valor
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Documento
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Selecionar
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                 <tr v-for="(item, index) in ListaSinistroDebitoDocumentos"
                                                                    :key="index">
                                                                    <td>{{ item.docNome }}</td>
                                                                     <td>{{ formattedDate(item.sdbDtDebito) }}</td>
                                                                     <td>{{ formatarValor(item.sdbValorDebito) }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="item.sddNomeInterno != ''" icon
                                                                            @click.prevent="VisualizarDocumento(item.sddNomeInterno)"
                                                                            variant="text">
                                                                            <v-icon>mdi-file-eye</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Visualizar</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                    <td style="text-align: center;">
                                                                         <v-checkbox v-model="item.sdbAprovado"
                                                                            density="compact"
                                                                            hide-details
                                                                            />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                    <v-row>
                                                        <p class="gp-approval-total">
                                                        Total aprovado: {{ formatarValor(TotalAprovados) }}
                                                        </p>
                                                    </v-row>
                                                    <v-row>
                                                         <v-col cols="12" md="12">
                                                        <label>Observações</label>
                                                        <textarea cols="5" rows="5" style="width: 100%;" class="form-control" v-model="Sinistro.sntStatusObs" maxlength="255"
                                                            placeholder="Observações">
                                                        </textarea>
                                                            </v-col>
                                                    </v-row>
                                                     <v-row class="gp-approval-actions">
                                                        <v-col cols="12" md="auto">
                                                            <button type="button" class="btn btn-success" style="color:#ffffff;" :disabled="processandoSituacao" @click="PutSituacao(30)">
                                                                <v-icon size="16">mdi-check-circle-outline</v-icon> Aprovar sinistro
                                                            </button>
                                                        </v-col>
                                                        <v-col cols="12" md="auto">
                                                            <button type="button" class="btn btn-danger" style="color:#ffffff;" :disabled="processandoSituacao" @click="PutSituacao(-10)">
                                                                <v-icon size="16">mdi-close-circle-outline</v-icon> Reprovar sinistro
                                                            </button>
                                                        </v-col>
                                                         <v-col cols="12" md="auto">
                                                            <button type="button" class="btn btn-outline-secondary" :disabled="processandoSituacao" @click="PutSituacao(10)">
                                                                <v-icon size="16">mdi-undo-variant</v-icon> Retornar pendente
                                                            </button>
                                                        </v-col>
                                                    </v-row>
                                                    </section>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-window-item>
                            </v-window>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { abrirArquivoAutenticado } from '../../utils/authenticatedFiles'
import axios from 'axios'
import { personalizarEmailGarantidora } from '../../utils/guarantorEmail'
import EasyDataTable from 'vue3-easy-data-table'
import moment from 'moment'
import { useRoute } from 'vue-router'

export default {
  name: 'SinistroAprovacaoDetalheView',
  components: {
    EasyDataTable,
    moment
  },
  setup () {
    const route = useRoute()
    const id = route.params.id
    return {
      id
    }
  },
  data: () => ({
    tab: null,
    User: {
      garid: 0,
      tpeid: 0,
      pesid: 0,
      cusid: 0
    },
    searchValue: '',
    MostraGrid: true,
    processandoSituacao: false,
    emailPagamento: null,
    emailCobranca: null,
    headers: [],
    Sinistro: {
      sntId: 0,
      sntIdCript: '',
      tsnId: 0,
      sntCodigo: '',
      sntDescricao: '',
      sntDtinclusao: '',
      cusId: null,
      imoId: null,
      garId: null,
      pedId: null,
      sstIdAtual: null,
      sntStatusObs: ''
    },
    SinistroDebito: {
      sdbId: 0,
      sdbIdCript: '',
      sntId: 0,
      cusId: null,
      sdbDtInclusao: '',
      sdbValorDebito: 0,
      sdbDtDebito: ''
    },
    ListSinistrosGeral: [],
    SituacoesSinistro: [],
    // pedidoendereco
    PedidosEndereco: [],
    PedidoItem: [],
    PedidoItemAdicional: [],
    PedidoDocumento: [],
    // documentos
    selectedFile: '',
    selectedFileDebito: '',
    DocSelected: null,
    DocSelectedDebito: null,
    ListaDocumentos: [],
    ListaDebitoDocumentos: [],
    ListaSinistroDocumentos: [],
    ListaSinistroDebitoDocumentos: [],
    ListaSinistrosPagamento: [],
    ListaSinistrosDebitoAndamento: [],
    TotalSinistrosPagamento: 0,
    TotalSinistroDebitoAndamento: 0,
    TotalCobertura: 0,
    DadosPedidoDocumento: ''
  }),
  methods: {
    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    preprocessData (data) {
      return data.map(item => {
        return {
          ...item,
          proOrdem: parseInt(item.proOrdem)
        }
      })
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    },
    async UploadImg (value) {
      const formData = new FormData()
      formData.append('file', value)
      const uploadResult = await axios.post('/Telas/SinistroAprovacaoDetalhe/upload', formData)
      return uploadResult
    },
    buildFileUrl (path) {
      if (!path) return ''
      const rel = String(path).replace(/\\/g, '/') // normaliza separadores
      const base = this.$imgURL
      return `${base}/Telas/SinistroAprovacaoDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}`
    },
    async openInNewTab (path) {
      try {
        await abrirArquivoAutenticado('/Telas/SinistroAprovacaoDetalhe/GetFileByParam', path)
      } catch (error) {
        this.$mensagemErro(error.message)
      }
    },
    VisualizarDocumento (item) {
      if (item) {
        this.openInNewTab(item)
      }
    },
    // enderecoPedido
    async SelecionarEnderecoPedido () {
      this.PedidosEndereco = []
      await axios.get('/Telas/SinistroAprovacaoDetalhe/GetAllByPedIdEndereco/' + this.Sinistro.pedId)
        .then(response => {
          this.PedidosEndereco = response.data
          // console.log('PedidosEndereco')
          // console.log(this.PedidosEndereco)
        })
        .catch(error => {
          console.error(error)
        })
    },
    async PutSituacao (value) {
      if (this.processandoSituacao) return
      if (value == 30 && this.ListaSinistroDebitoDocumentos.filter(x => x.sdbAprovado === true).length == 0) return this.$mensagemAviso('Algum item precisar estar aprovado.')
      if (this.Sinistro.sntStatusObs == '' || this.Sinistro.sntStatusObs == null) return this.$mensagemAviso('Preencha observação.')

      this.processandoSituacao = true
      let statusSalvo = false
      try {
        // altera o sinistro
        await Promise.all(this.ListaSinistroDebitoDocumentos.map(element => {
          const sinistroDebito = {
            sdbId: element.sdbId,
            sntId: element.sntId,
            cusId: element.cusId,
            sdbValorDebito: element.sdbValorDebito,
            sdbDtDebito: element.sdbDtDebito,
            sdbAprovado: value == 30 ? element.sdbAprovado : false
          }
          return axios.put('/Telas/SinistroAprovacaoDetalhe/PutSinistroDebito', sinistroDebito)
        }))

        this.Sinistro.sstIdAtual = value
        const { data } = await axios.put('/Telas/SinistroAprovacaoDetalhe/PutSinistro', this.Sinistro)
        if (!(data > 0)) throw new Error('Alteração de status não confirmada.')
        statusSalvo = true
        await this.AddHistoricoStatus(value, this.Sinistro.sntStatusObs)
        if (value === 30) {
          await this.AddSinistroPagamento()
          await this.AddSinistroCobranca()
        }
        const parcial = this.ListaSinistroDebitoDocumentos.filter(x => x.sdbAprovado === false).length
        try {
          await this.EnviaAvisoImobiliaria(value, this.Sinistro.sntStatusObs, parcial)
        } catch (erro) {
          this.$mensagemAviso('Status salvo. ' + (erro.message || 'Não foi possível confirmar o aviso de status.'))
        }
        this.$router.push('/listasinistrosaprovacao')
      } catch (erro) {
        this.$mensagemErro(statusSalvo
          ? 'Status salvo, mas o processamento não foi concluído. O aviso de status não foi enviado. Confira o histórico, o pagamento e a cobrança antes de tentar novamente.'
          : 'Não foi possível confirmar a alteração do sinistro.')
        if (statusSalvo) this.$router.push('/listasinistrosaprovacao')
      } finally {
        this.processandoSituacao = false
      }
    },
    // HistoricoStatus
    async AddHistoricoStatus (item, obs) {
      const _hist = {
        shsId: 0,
        sntId: this.Sinistro.sntId,
        shsDtInclusao: moment().format('YYYY-MM-DDTHH:mm:ss'),
        sstId: item,
        cusId: this.User.cusid,
        shsStatusObs: obs
      }
      await axios.post('/Telas/SinistroAprovacaoDetalhe/AddSinistroHistoricoStatus', _hist)
    },
    async EnviaAvisoImobiliaria (value, obs, parcial) {
      const { data: modelo } = await axios.get(`/Telas/SinistroAprovacaoDetalhe/GetByIdMensagemPadrao/21?garId=${this.Sinistro.garId || 0}`)
      if (!modelo?.mpdTexto) throw new Error('Mensagem 21 não encontrada.')
      const status = value === 10 ? 'PENDENTE' : value === -10 ? 'REPROVADO'
        : parcial > 0 ? 'EM ANDAMENTO, COM APROVAÇÃO PARCIAL' : 'EM ANDAMENTO'
      const contatos = [[this.Sinistro.imoEmail, this.Sinistro.imoNome]]
      if (value === 30) contatos.push([this.emailPagamento, 'Pagamento'], [this.emailCobranca, 'Cobrança'])
      const destinos = new Map()
      for (const [campo, nome] of contatos) {
        for (const item of String(campo || '').split(/[;,]/)) {
          const email = item.trim().toLowerCase()
          if (email && !destinos.has(email)) destinos.set(email, nome)
        }
      }
      if (!destinos.size) throw new Error('Nenhum destinatário cadastrado para a mensagem 21.')
      const aviso = await personalizarEmailGarantidora({
        nomeDe: this.Sinistro.garNome,
        assunto: 'Status de Sinistro: ' + this.Sinistro.sntCodigo,
        emailResposta: this.Sinistro.garEmail,
        textoEmail: modelo.mpdTexto.replace('[CodSinistro]', this.Sinistro.sntCodigo)
          .replace('[NovoStatus]', status).replace('[TextoObs]', obs),
        listAnexos: null
      }, this.Sinistro.garId || this.User.garid || 0, this.$imgURL, this.$GarantePayLinkAcesso, this.$GarantePayEmail)
      const falhas = []
      for (const [destinatario, nomePara] of destinos) {
        try {
          const envio = await axios.post('/Telas/SinistroAprovacaoDetalhe/Enviamail', { ...aviso, destinatario, nomePara })
          if (envio.data !== 1) throw new Error()
        } catch {
          falhas.push('Envio não confirmado para ' + destinatario + '.')
          continue
        }
        try {
          await axios.post('/Telas/SinistroAprovacaoDetalhe/AddSinistroEnvioEmail', {
            seeId: 0, sntId: this.Sinistro.sntId, seeDtEnvio: moment().format('YYYY-MM-DDTHH:mm:ss'),
            seeEmailDestinatario: destinatario, seeTipoEnvio: modelo.mpdNome
          })
        } catch {
          falhas.push('Aviso encaminhado para ' + destinatario + ', mas não registrado no histórico.')
        }
      }
      if (falhas.length) throw new Error(falhas.join(' '))
    },
    // Add Sinistro Pagamento
    async AddSinistroPagamento () {
      const _pagamento = {
        snpId: 0,
        sntId: this.Sinistro.sntId,
        snpDtinclusao: moment().format('YYYY-MM-DDTHH:mm:ss'),
        snpValor: parseFloat(this.TotalAprovados),
        snpDtpagamento: null,
        snpDtAgendamento: null,
        pstIdatual: 10,
        snpObservacao: ''
      }

      const result = await axios.post('/Telas/SinistroAprovacaoDetalhe/AddSinistroPagamento', _pagamento)
      const Id = result?.data
      if (!(Id > 0)) throw new Error('Pagamento não confirmado.')
      await this.AddHistoricoPagamentoStatus(Id, 10, '')
      this.EnviaAvisoPagamentoImobiliaria(10, '')
    },
    // Add Sinistro Cobranca
    async AddSinistroCobranca () {
      const _cobranca = {
        sncId: 0,
        pedId: this.Sinistro.pedId,
        sncDtinclusao: moment().format('YYYY-MM-DDTHH:mm:ss'),
        scbIdatual: 10
      }

      const { data } = await axios.post('/Telas/SinistroAprovacaoDetalhe/AddSinistroCobranca', _cobranca)
      if (!(data > 0)) throw new Error('Cobrança não confirmada.')
    },
    // Historico pagamento
    async AddHistoricoPagamentoStatus (item, status, obs) {
      const _hist = {
        sphId: 0,
        snpId: item,
        sphDtInclusao: moment().format('YYYY-MM-DDTHH:mm:ss'),
        pstId: status,
        cusId: this.User.cusid,
        sphObservacao: obs
      }
      await axios.post('/Telas/SinistroAprovacaoDetalhe/AddSinistroPagamentoHistoricoStatus', _hist)
    },
    async EnviaAvisoPagamentoImobiliaria (value, obs) {
      await axios.get(`/Telas/SinistroAprovacaoDetalhe/GetByIdMensagemPadrao/22?garId=${this.Sinistro.garId || 0}`)
        .then(async response => {
          this.templateEmail = response.data

          const _texto = 'AGUARDANDO PAGAMENTO'

          const _dadosEmail = {
            nomeDe: this.Sinistro.garNome,
            nomePara: this.Sinistro.imoNome,
            assunto: 'Status de Pagamento Sinistro: ' + this.Sinistro.sntCodigo,
            destinatario: this.Sinistro.imoEmail,
            emailResposta: this.Sinistro.garEmail,
            textoEmail: this.templateEmail.mpdTexto.replace('[CodSinistro]', this.Sinistro.sntCodigo)
              .replace('[NovoStatus]', _texto)
              .replace('[TextoResumo]', '')
              .replace('[TextoObs]', obs),
            listAnexos: null
          }
          const emailPersonalizado = await personalizarEmailGarantidora(_dadosEmail, this.Sinistro.garId || this.User.garid || 0, this.$imgURL, this.$GarantePayLinkAcesso, this.$GarantePayEmail).catch(error => {
            this.$mensagemErro(error.message || 'Não foi possível carregar a identificação da garantidora para o e-mail.')
            return null
          })
          if (!emailPersonalizado) return
          axios.post('/Telas/SinistroAprovacaoDetalhe/Enviamail', emailPersonalizado)
            .then(response => {
              // console.log(response.data)
              const _envio = {
                seeId: 0,
                sntId: this.Sinistro.sntId,
                seeDtEnvio: moment().format('YYYY-MM-DDTHH:mm:ss'),
                seeEmailDestinatario: this.Sinistro.imoEmail,
                seeTipoEnvio: this.templateEmail.mpdNome
              }
              axios.post('/Telas/SinistroAprovacaoDetalhe/AddSinistroEnvioEmail', _envio)
            })
        })
    },
    dadosContrato (value) {
      const raw = value
      try {
        const obj = typeof raw === 'object' && raw !== null ? raw : JSON.parse(raw)

        // helpers de normalização
        const toNum = v => (v === '' || v == null) ? 0 : Number(String(v).replace(',', '.')) || 0
        const toNumX = v => { // "22x" -> 22
          const m = String(v || '').match(/\d+/)
          return m ? Number(m[0]) : 0
        }

        return {
          idPedido: obj.idPedido,
          multiplicador: toNumX(obj.multiplicador), // 22
          custoSaida: toNumX(obj.custoSaida), // 3
          valorContratado: toNum(obj.valorContratado), // 246
          valorLocaticio: toNum(obj.valorLocaticio), // 0
          valorTaxa: toNum(obj.valorTaxa), // 0.08
          setup: toNum(obj.setup) // 150
        }
      } catch (e) {
        console.warn('JSON inválido em pftDadosContrato:', e)
        return {}
      }
    },
    async Get () {
      let _id = ''
      if (this.id != '') {
        _id = this.id
      }
      await axios.get('/Telas/SinistroAprovacaoDetalhe/GetDados/' + _id)
        .then(response => {
          const d = response?.data ?? {}

          // ───────── Helpers ─────────
          const asArr = v => Array.isArray(v) ? v : []
          const first = a => (Array.isArray(a) && a.length) ? a[0] : null
          const toNum = v => (v == null || v === '') ? 0 : Number(String(v).replace(/\./g, '').replace(',', '.')) || 0
          const sumBy = (list, selector) => asArr(list).reduce((acc, item) => acc + (selector(item) || 0), 0)

          // Parse seguro do JSON de pftDadosContrato (string -> objeto)
          const parseDadosContrato = raw => {
            try {
              const obj = (raw && typeof raw === 'object')
                ? raw
                : (typeof raw === 'string' && raw.trim() !== '' ? JSON.parse(raw) : {})
              // Normalizações básicas (ajuste se quiser manter como string)
              const toNumX = v => { const m = String(v ?? '').match(/\d+/); return m ? Number(m[0]) : 0 }
              return {
                idPedido: obj.idPedido ?? null,
                multiplicador: toNumX(obj.multiplicador),
                custoSaida: toNumX(obj.custoSaida),
                valorContratado: toNum(obj.valorContratado),
                valorLocaticio: toNum(obj.valorLocaticio),
                valorTaxa: toNum(obj.valorTaxa),
                setup: toNum(obj.setup)
              }
            } catch {
              return {}
            }
          }

          // ───────── Atribuições seguras ─────────
          this.User.tpeid = d.tpeId ?? null
          this.User.garid = d.garId ?? null
          this.User.cusid = d.cusId ?? null
          this.User.pesid = d.pesId ?? null

          this.emailPagamento = d.emailPagamento
          this.emailCobranca = d.emailCobranca
          this.Sinistro = d.sinistro ?? {} // pode vir null

          this.PedidoItem = first(d.pedidoItem) ?? {} // [0] seguro
          this.PedidoItemAdicional = asArr(d.pedidoItemAdicional) // array ou []
          this.PedidoDocumento = asArr(d.pedidoDocumentos) // array ou []
          this.ListaSinistroDocumentos = asArr(d.sinistroDocumento)
          this.ListaSinistrosPagamento = asArr(d.sinistroPagamento)
          this.ListaSinistrosDebitoAndamento = asArr(d.sinistroDebitoAndamento)

          // pftDadosContrato do primeiro documento, se existir
          const doc0 = first(this.PedidoDocumento)
          this.DadosPedidoDocumento = doc0 ? parseDadosContrato(doc0.pftDadosContrato) : {}

          // Totais (somando com conversão para número)
          this.TotalSinistrosPagamento = sumBy(this.ListaSinistrosPagamento, i => (i.snpValor))
          this.TotalSinistroDebitoAndamento = sumBy(this.ListaSinistrosDebitoAndamento, i => (i.sdbValorDebito))
          this.TotalCobertura = sumBy(this.PedidoItemAdicional, i => toNum(i.piaValorTotalProduto))

          const debitos = asArr(d.sinistroDebito)
          const docs = asArr(d.sinistroDebitoDocumento)

          if (debitos.length > 0) {
            // opcional: manter o primeiro em SinistroDebito
            this.SinistroDebito = { ...debitos[0] }

            // cria lookup: sdbId -> debito
            const debitoPorId = debitos.reduce((acc, deb) => {
              acc[deb.sdbId] = deb
              return acc
            }, {})

            this.ListaSinistroDebitoDocumentos = docs.map(doc => {
              const deb = debitoPorId[doc.sdbId]
              return deb ? { ...doc, ...deb } : doc
            })
          } else {
            this.SinistroDebito = {}
            this.ListaSinistroDebitoDocumentos = []
          }

          console.log('this.SinistroDebito')
          console.log(this.SinistroDebito)
          console.log('this.ListaSinistroDebitoDocumentos')
          console.log(this.ListaSinistroDebitoDocumentos)

          // Chama só no final (se depender dos dados acima)
          if (this.Sinistro != '') {
            this.SelecionarEnderecoPedido?.()
          }

          // console.log('this.Sinistro')
          //  console.log(this.Sinistro)
        })
        .catch(err => {
          console.error('Erro ao buscar dados do sinistro:', err)
          // Defaults seguros em caso de erro
          this.Sinistro = {}
          this.PedidoItem = {}
          this.PedidoItemAdicional = []
          this.PedidoDocumento = []
          this.ListaSinistroDocumentos = []
          this.ListaSinistrosPagamento = []
          this.ListaSinistrosDebitoAndamento = []
          this.DadosPedidoDocumento = {}
          this.TotalSinistrosPagamento = 0
          this.TotalSinistroDebitoAndamento = 0
          this.TotalCobertura = 0
          this.SinistroDebito = {}
          this.ListaSinistroDebitoDocumentos = []
        })
    }
  },
  created () {
    this.Get()
  },
  computed: {
    TotalAprovados () {
      return (this.ListaSinistroDebitoDocumentos || [])
        .filter(item => item.sdbAprovado === true || item.sdbAprovado === 1 || item.sdbAprovado === 'true')
        .reduce((total, item) => {
          return total + (Number(item.sdbValorDebito) || 0)
        }, 0)
    }
  }

}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}

.fontaprova {
    font-size: 16px;
    font-weight: 600;
}
.gp-approval-card { overflow: hidden; border: 1px solid #e1d9cd; border-radius: 14px; }
.gp-approval-card > .card-body { padding: 0; }
.gp-approval-card :deep(.gp-client-tabs) { padding: 8px 14px 0; border-bottom: 1px solid #e8e1d7; background: #fcfaf7; }
.gp-approval-card :deep(.v-tab) { gap: 6px; }
.gp-approval-info-card,
.gp-approval-decision-card { height: 100%; padding: 15px; border: 1px solid #e1d9cd; border-radius: 12px; background: #fff; box-shadow: none; }
.gp-approval-details-row { margin-top: 4px; }
.gp-approval-card-title { display: flex; align-items: center; gap: 7px; margin: -15px -15px 14px; padding: 12px 15px; border-bottom: 1px solid #e8e1d7; background: #fcfaf7; color: #102a5a; font-size: 13px; font-weight: 800; }
.gp-approval-card-title .v-icon { color: #d96f00; }
.gp-approval-info-card .texto-mensagem { margin-bottom: 7px !important; color: #4d586d !important; font-size: 11.5px !important; line-height: 1.45; }
.gp-approval-balance { margin: 12px 0; padding: 11px 13px; border: 1px solid #b9dccb; border-radius: 10px; background: #edf9f3; color: #146b48; font-size: 14px; }
.gp-approval-description { margin: 12px 0 12px 15px; padding: 10px 12px; border-left: 4px solid #e77900; border-radius: 8px; background: #fff5e8; color: #9a4f00; font-size: 12px; font-weight: 700; }
.gp-approval-total { display: flex; justify-content: flex-end; margin: 12px 0 0 15px; padding: 11px 13px; border-radius: 10px; background: #102a5a; color: #fff; font-size: 13px; font-weight: 800; }
.gp-approval-card :deep(.v-table) { overflow: hidden; border: 1px solid #e8e1d7; border-radius: 10px; font-size: 10.5px; margin: 10px 0 10px 15px; }
.gp-approval-card :deep(.v-table th) { background: #f1ede7; color: #42506a; font-size: 9px; text-transform: uppercase; }
.gp-approval-card textarea { min-height: 90px; resize: vertical; border-radius: 9px; font-size: 12px; }
.gp-approval-actions { display: flex; justify-content: flex-end; gap: 8px; margin: 8px 0 0; padding-top: 13px; border-top: 1px solid #e8e1d7; }
.gp-approval-actions > [class*="v-col"] { flex: 0 0 auto; padding: 0; }
.gp-approval-actions .btn { min-height: 36px; display: inline-flex; align-items: center; justify-content: center; gap: 6px; }
@media(max-width:767.98px){
    .gp-approval-info-card,.gp-approval-decision-card{padding:13px}
    .gp-approval-card-title{margin:-13px -13px 12px}
    .gp-approval-actions{align-items:stretch;flex-direction:column}
    .gp-approval-actions .btn{width:100%}
}
</style>
